/* dp-lade.js — de nieuwe winkelwagen-lade van dailyplay.nl (Wim, 24-10-2026). Bron in git: shopify/dp-lade.js;
   in het thema assets/dp-lade.js, geladen in layout/theme.liquid (defer) direct ná assets/dp-ab.js, met
   assets/dp-lade.css in <head>.

   WIE HEM ZIET (Damian 24-10: "de lade moet mee met alle nieuwe productpaginas"): precies de browsers in arm B van de
   paginatest mvmq7ych-34xx7j. Geen eigen loting: dit script leest de arm die dp-split.liquid en dp-ab.js al hebben
   vastgelegd (localStorage dp-ab-groep-<test> of de cookie dp_ab_<test>), en doet alleen iets als de test loopt
   (dp-ab-open-<test> = 1), als B gehouden is (dp-ab-open-<test> = B) of in een proefbrowser (dp-ab-proef-<test> = 1,
   gezet door ?dp_ab=A|B op een testpagina). Arm A en elke browser zonder arm houden de lade van nu (Kaching).

   HOE: Kaching blijft de lade die het werk doet (wagen, cadeautredes, upsell-korting, afrekenen); in arm B wordt zijn
   lade onzichtbaar en ligt er een eigen paneel precies overheen, in de vorm van het canvas "Side cart Dailyplay"
   (artboard Korting). Elke knop in het paneel drukt op de knop van Kaching zelf (aantal, verwijderen, upsell
   toevoegen, betalen), zodat elke korting precies blijft zoals hij nu is. De cijfers komen uit /cart.js (Shopify
   rekent de kortingen van Kaching daar al in), de adviesprijs uit /products/<handle>.js, het starterspakket uit
   de sectie dp-cart-cadeaus (dezelfde bron als de lade van nu) en de cadeautredes uit Kachings eigen instellingen.
   De voet sluit op de cent op cart.total_price; sluit hij niet, dan toont hij alleen subtotaal en totaal.

   METEN (beide armen, alleen als de test loopt of in de proef): "lade" = in deze sessie ging de lade open met iets
   in de wagen; "afrekenen" = in die sessie werd er in de lade op Betalen gedrukt. Weergave = "l" + de sessie-id van
   dp-ab.js (30 minuten), dus hooguit één van elk per sessie (uniek in de database). Naar afrekenen = afrekenen ÷ lade.

   Alles staat in try/catch: faalt iets, dan haalt het script zijn paneel weg en is de lade weer die van Kaching. */
(function () {
  "use strict";
  var T = "mvmq7ych-34xx7j";
  var COCKPIT = "https://dailyplay-cockpit.vercel.app";
  var OPEN_KLASSE = "kaching-body__cart-open";

  function lees(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function schrijf(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* privé-venster */ } }
  function leesCookie(n) { try { var m = document.cookie.match(new RegExp("(?:^|; )" + n + "=([^;]*)")); return m ? decodeURIComponent(m[1]) : null; } catch (e) { return null; } }
  function toeval(n) { var s = ""; while (s.length < n) s += Math.random().toString(36).slice(2); return s.slice(0, n); }

  /** De arm van deze browser in de paginatest, of null als de lade van nu blijft. */
  function paginaArm() {
    var open = lees("dp-ab-open-" + T), proef = lees("dp-ab-proef-" + T) === "1";
    if (open === "B") return { arm: "B", meld: false, proef: false };
    if (open !== "1" && !proef) return null;
    var arm = lees("dp-ab-groep-" + T) || leesCookie("dp_ab_" + T);
    if (arm !== "A" && arm !== "B") return null;
    return { arm: arm, meld: true, proef: proef };
  }

  /* ── meten ─────────────────────────────────────────────────────────────────────────────────────────────── */
  function apparaat() { return window.matchMedia && window.matchMedia("(max-width: 768px)").matches ? "mobiel" : "desktop"; }
  function bezoeker() { var b = lees("dp-ab-bezoeker"); if (!b) { b = toeval(16); schrijf("dp-ab-bezoeker", b); } return b; }
  function weergave() {
    var id = null;
    try { var s = JSON.parse(lees("dp-ab-sessie") || "null"); id = s && s.id; } catch (e) { id = null; }
    if (!/^[a-z0-9]{10,30}$/.test(id || "")) {
      try { id = sessionStorage.getItem("dp-lade-sessie"); } catch (e) { id = null; }
      if (!id) { id = toeval(16); try { sessionStorage.setItem("dp-lade-sessie", id); } catch (e) { /* niets */ } }
    }
    return "l" + id;
  }
  function meld(soort, stand) {
    try {
      if (!stand || !stand.meld) return;
      var w = weergave();
      var g = {}; try { g = JSON.parse(lees("dp-lade-gemeld") || "{}") || {}; } catch (e) { g = {}; }
      if (g.w !== w) g = { w: w };
      if (g[soort]) return;
      if (soort === "afrekenen" && !g.lade) meld("lade", stand);   // afrekenen telt alleen naast een lade
      g = JSON.parse(lees("dp-lade-gemeld") || "{}") || {}; if (g.w !== w) g = { w: w };
      g[soort] = 1; schrijf("dp-lade-gemeld", JSON.stringify(g));
      var rij = { t: T, v: stand.arm, s: soort, h: "lade", w: w, b: bezoeker(), a: apparaat() };
      if (stand.proef) rij.p = 1;
      var body = JSON.stringify(rij);
      if (navigator.sendBeacon && navigator.sendBeacon(COCKPIT + "/api/ab-gebeurtenis", body)) return;
      fetch(COCKPIT + "/api/ab-gebeurtenis", { method: "POST", body: body, keepalive: true, mode: "cors" }).catch(function () {});
    } catch (e) { /* een storing in de teller raakt de winkel nooit */ }
  }

  /* ── rekenen ───────────────────────────────────────────────────────────────────────────────────────────── */
  function geld(c) {
    var n = Math.round(Number(c) || 0);
    if (n === 0) return "€0";
    var neg = n < 0; n = Math.abs(n);
    var e = String(Math.floor(n / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return (neg ? "−" : "") + "€" + e + "," + String(n % 100 + 100).slice(1);
  }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (x) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[x]; }); }
  function eenheid(s) { return String(s).replace(/(\d)\s*(kg|cm|ml|mm|g)\b/gi, function (_, d, u) { return d + " " + u.toLowerCase(); }); }
  function zin(s) {
    var w = String(s).trim().split(/\s+/);
    return w.map(function (x, i) { return i > 0 && /^[A-Z][a-zà-ÿ]+$/.test(x) ? x.toLowerCase() : x; }).join(" ").replace(/^./, function (c) { return c.toUpperCase(); });
  }
  /** Korte naam en onderregel uit een producttitel: "Sekspop - Billen - 15kg - 48cm - Loes" → Loes / Billen · 15 kg. */
  function kort(titel, variant) {
    var t = String(titel || "").replace(/\s+/g, " ").trim(), naam = t, sub = "";
    var d = t.split(/\s+[-–]\s+/).filter(Boolean);
    var laatste = d[d.length - 1] || "";
    // een modelnaam staat achteraan: één woord ("Loes", "LexaNL"), of bij drie delen of meer een naam van hooguit vier
    // woorden ("Anouk Maze", "Nina van der Wilde"); de soort ervóór wordt de onderregel, nooit het woord sekspop
    var eenWoord = /^[A-ZÀ-Ý][A-Za-zà-ÿ]{1,13}$/.test(laatste);
    var meerWoord = d.length >= 3 && !/\d/.test(d.slice(1, -1).join(" ")) && laatste.length <= 24 && /^[A-ZÀ-Ý][A-Za-zà-ÿ]+(?:\s+(?:van|de|der|den|[A-ZÀ-Ý][A-Za-zà-ÿ]+)){1,3}$/.test(laatste);
    if (d.length >= 2 && (eenWoord || meerWoord)) {
      naam = laatste;
      sub = (d.length === 2 ? [d[0]] : d.slice(1, -1).slice(0, 2)).filter(function (x) { return !/seks|sex/i.test(x); }).map(function (x) { return zin(eenheid(x)); }).join(" · ");
    } else if (d.length >= 2) {
      naam = d[0]; sub = zin(eenheid(d[1]));
    } else {
      var m = t.match(/^(.+?)\s+(met\s+.+)$/i);
      if (m) { naam = m[1]; sub = zin(m[2]); }
    }
    if (variant && !/^default title$/i.test(variant)) sub = sub ? sub + " · " + variant : variant;
    return { naam: naam, sub: sub };
  }
  function isCadeau(item) {
    var k = item && item.properties && item.properties._kaching_cart;
    return !!(k && /promoHash/.test(String(k)) && /product-discount/.test(String(k)));
  }

  /** De voet: subtotaal (incl. de waarde van alles wat gratis is), gratis cadeaus, korting per product, totaal. */
  function voetRegels(cart, info, cadeaus) {
    var subtotaal = 0, gratis = 0, kortingen = [], perNaam = {};
    (cart.items || []).forEach(function (it) {
      if (isCadeau(it)) {
        subtotaal += it.original_line_price;
        gratis += it.original_line_price - it.final_line_price;
        return;
      }
      var v = info[it.handle] && info[it.handle].varianten[it.variant_id];
      var adv = v && v.compare_at_price > it.original_price ? v.compare_at_price * it.quantity : it.original_line_price;
      subtotaal += adv;
      var k = (adv - it.original_line_price) + (it.original_line_price - it.final_line_price);
      if (k > 0) {
        var naam = kort(it.product_title).naam;
        if (perNaam[naam] == null) { perNaam[naam] = kortingen.length; kortingen.push({ naam: "Korting op " + naam, bedrag: 0 }); }
        kortingen[perNaam[naam]].bedrag += k;
      }
      var pak = pakketWaarde(cadeaus, it.product_id);
      subtotaal += pak; gratis += pak;
    });
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      var b = Number(a.total_allocated_amount) || 0;
      if (b > 0) kortingen.push({ naam: a.type === "discount_code" ? "Kortingscode " + a.title : (a.title || "Korting"), bedrag: b });
    });
    var bespaard = gratis + kortingen.reduce(function (s, k) { return s + k.bedrag; }, 0);
    var sluit = subtotaal - bespaard === cart.total_price;
    return { subtotaal: subtotaal, gratis: gratis, kortingen: kortingen, bespaard: bespaard, totaal: cart.total_price, sluit: sluit };
  }
  function pakketWaarde(cadeaus, pid) {
    var l = cadeaus && cadeaus[String(pid)];
    if (!l || !l.length) return 0;
    var s = 0;
    for (var i = 0; i < l.length; i++) { var c = Number(l[i] && l[i].c); if (!(c > 0)) return 0; s += c; }   // één onbekende waarde = geen bedrag
    return s;
  }
  /** De cadeautredes van Kaching voor dit land: {tiers, totaal} of null. */
  function treden(cart) {
    try {
      var p = window.__kachingCartProps, tp = p.cartSettings.tieredPromotionsBar;
      if (!tp || !tp.isActive) return null;
      var tiers = tp.tiers || [], land = p.countryCode;
      (tp.marketSpecificTiers || []).forEach(function (m) { if ((m.countryCodes || []).indexOf(land) >= 0) { tiers = m.hidePromoBar ? [] : (m.tiers || []); } });
      tiers = tiers.filter(function (t) { return t && typeof t.threshold === "number"; }).sort(function (a, b) { return a.threshold - b.threshold; });
      if (!tiers.length) return null;
      return { tiers: tiers, totaal: (cart.total_price || 0) / 100 };
    } catch (e) { return null; }
  }

  /* ── bronnen ───────────────────────────────────────────────────────────────────────────────────────────── */
  var info = {};          // handle → {varianten: {id: {compare_at_price}}}
  var infoBezig = {};
  // de adviesprijzen blijven 10 minuten bewaard over de pagina's van deze sessie, zodat de lade na een klik niet op
  // /products/<handle>.js hoeft te wachten (25-10); alleen een geslaagde lezing wordt bewaard
  var INFO_SLEUTEL = "dp-lade-info-v1", INFO_MS = 10 * 60 * 1000;
  try {
    var bewaard = JSON.parse(sessionStorage.getItem(INFO_SLEUTEL) || "{}") || {};
    Object.keys(bewaard).forEach(function (h) { if (bewaard[h] && Date.now() - bewaard[h].op < INFO_MS) info[h] = { varianten: bewaard[h].varianten }; });
  } catch (e) { /* zonder sessionStorage gewoon per pagina */ }
  function bewaarInfo(handle) {
    try {
      var b = JSON.parse(sessionStorage.getItem(INFO_SLEUTEL) || "{}") || {};
      b[handle] = { op: Date.now(), varianten: info[handle].varianten };
      sessionStorage.setItem(INFO_SLEUTEL, JSON.stringify(b));
    } catch (e) { /* niets */ }
  }
  function haalInfo(handle) {
    if (info[handle] || infoBezig[handle]) return infoBezig[handle] || Promise.resolve();
    infoBezig[handle] = fetch("/products/" + encodeURIComponent(handle) + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var v = {};
        ((p && p.variants) || []).forEach(function (x) { v[x.id] = { compare_at_price: Number(x.compare_at_price) || 0 }; });
        info[handle] = { varianten: v };
        if (p && p.variants) bewaarInfo(handle);
      })
      .catch(function () { info[handle] = { varianten: {} }; });
    return infoBezig[handle];
  }
  var cadeaus = null, cadeauSig = null;
  /** De sectie dp-cart-cadeaus zonder op /cart.js te wachten (25-10, de pauze na In winkelwagen): ze rendert zelf uit
      de wagen op de server. Geeft {data} of null; haalCadeaus gebruikt hem alleen als hij elk product van de wagen kent. */
  function cadeausVoorschot() {
    return fetch("/?sections=dp-cart-cadeaus", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var html = j && j["dp-cart-cadeaus"];
        var m = html && html.match(/<script type="application\/json" data-dp-cadeaus>([\s\S]*?)<\/script>/);
        return m ? JSON.parse(m[1]) : null;
      })
      .catch(function () { return null; });
  }
  function haalCadeaus(ids, voorschot) {
    var sig = ids.slice().sort().join(",");
    if (sig === cadeauSig && cadeaus) return Promise.resolve(cadeaus);
    if (voorschot) {
      return voorschot.then(function (d) {
        if (d && ids.every(function (id) { return Object.prototype.hasOwnProperty.call(d, id); })) { cadeaus = d; cadeauSig = sig; return d; }
        return haalCadeaus(ids);
      });
    }
    return fetch("/?sections=dp-cart-cadeaus", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var html = j && j["dp-cart-cadeaus"];
        var m = html && html.match(/<script type="application\/json" data-dp-cadeaus>([\s\S]*?)<\/script>/);
        cadeaus = m ? JSON.parse(m[1]) : {};
        cadeauSig = sig;
        return cadeaus;
      })
      .catch(function () { return cadeaus || {}; });
  }
  /** De upsell-kaarten die Kaching (en de upsell-test in dp-ab.js) nu zichtbaar heeft, hooguit drie. */
  function upsells() {
    var mod = document.querySelector(".kaching-upsell-module--product-upsell");
    if (!mod) return [];
    var uit = [];
    var kaarten = mod.querySelectorAll(".kaching-product-upsell-item");
    for (var i = 0; i < kaarten.length && uit.length < 3; i++) {
      var k = kaarten[i], verborgen = false;
      for (var e = k; e && e !== mod; e = e.parentElement) { if (e.style && e.style.display === "none") { verborgen = true; break; } }
      if (verborgen) continue;
      var knop = k.querySelector(".kaching-product-upsell-item__add-to-cart");
      if (!knop) continue;
      var tekst = function (sel) { var x = k.querySelector(sel); return x ? x.textContent.replace(/[⁦-⁩]/g, "").trim() : ""; };
      var img = k.querySelector("img");
      uit.push({ handle: k.getAttribute("data-product-handle"), titel: tekst(".kaching-product-upsell-item__title"), prijs: tekst(".kaching-product-upsell-item__price-final"), oud: tekst(".kaching-product-upsell-item__price-old"), beeld: img ? img.getAttribute("src") : "", knop: knop });
    }
    return uit;
  }

  /* ── tekenen ───────────────────────────────────────────────────────────────────────────────────────────── */
  var ICOON = {
    sluit: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"></path></svg>',
    vink: '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"></path></svg>',
    weg: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"></path></svg>',
    cadeau: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7c-2-4-6-3-6-1s4 1 6 1c2 0 6 1 6-1s-4-3-6 1"></path></svg>',
    doos: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#00c3be" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8l9-4 9 4v9l-9 4-9-4z"></path><path d="M3 8l9 4 9-4M12 12v9"></path></svg>',
    terug: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#00c3be" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9h11a5 5 0 0 1 0 10h-4"></path><path d="m8 5-4 4 4 4"></path></svg>'
  };
  function beeld(url, b) {
    if (!url) return "";
    var u = String(url);
    if (/cdn\.shopify\.com|\/cdn\/shop\//.test(u) && !/[?&]width=/.test(u)) u += (u.indexOf("?") >= 0 ? "&" : "?") + "width=" + b;
    return u;
  }
  function balkHtml(tr) {
    if (!tr) return "";
    var n = tr.tiers.length, tot = tr.totaal;
    var pos = function (i) { return n === 1 ? 100 : 30 + 70 * i / (n - 1); };
    var vul = 0;
    for (var i = 0; i < n; i++) {
      var t = tr.tiers[i];
      if (tot >= t.threshold) { vul = pos(i); continue; }
      var vorigeT = i === 0 ? 0 : tr.tiers[i - 1].threshold, vorigeP = i === 0 ? 0 : pos(i - 1);
      vul = vorigeP + (pos(i) - vorigeP) * Math.max(0, tot - vorigeT) / (t.threshold - vorigeT);
      break;
    }
    var bereikt = tr.tiers.filter(function (t) { return tot >= t.threshold; });
    var verzending = bereikt.some(function (t) { return t.type === "shipping-discount"; });
    var nCadeau = bereikt.filter(function (t) { return t.type === "product-discount"; }).length;
    var volgende = tr.tiers.filter(function (t) { return tot < t.threshold; })[0];
    var krijg = [];
    if (verzending) krijg.push("<b>gratis verzending</b>");
    if (nCadeau) krijg.push("<b>" + nCadeau + (nCadeau === 1 ? " cadeau" : " cadeaus") + "</b>");
    var tekst = krijg.length ? "Je krijgt " + krijg.join(" en ") : "";
    if (volgende) {
      var nodig = "<b>" + geld(Math.round((volgende.threshold - tot) * 100)) + "</b>";
      var wat = volgende.type === "shipping-discount" ? "<b>gratis verzending</b>" : "een <b>gratis cadeau</b>";
      tekst = tekst ? tekst + ", nog " + nodig + " voor " + wat : "Nog " + nodig + " voor " + wat;
    }
    var stappen = tr.tiers.map(function (t, i) {
      var P = pos(i), aan = tot >= t.threshold;
      return '<span class="dpl-balk-stap' + (aan ? " is-aan" : "") + '" style="left:calc(' + P + "% - " + (18 * P / 100) + 'px)">' + (aan ? ICOON.vink : "") + "</span>";
    }).join("");
    return '<div class="dpl-balk"><div class="dpl-balk-tekst">' + tekst + '</div><div class="dpl-balk-lijn"><div class="dpl-balk-spoor"><div class="dpl-balk-vul" style="width:' + Math.min(100, vul).toFixed(1) + '%"></div></div>' + stappen + "</div></div>";
  }
  function regelHtml(it) {
    var k = kort(it.product_title, it.variant_title);
    var v = info[it.handle] && info[it.handle].varianten[it.variant_id];
    var oud = v && v.compare_at_price > it.original_price ? v.compare_at_price * it.quantity : it.original_line_price;
    var prijs = '<span class="dpl-prijs"><b>' + geld(it.final_line_price) + "</b>" + (oud > it.final_line_price ? "<s>" + geld(oud) + "</s>" : "") + "</span>";
    var pak = pakketWaarde(cadeaus, it.product_id);
    var pakket = pak > 0 ? '<div class="dpl-pakket"><div class="dpl-pakket-rij"><span class="dpl-pakket-kop">' + ICOON.cadeau + "<span>Gratis starterspakket</span></span><span><s>" + geld(pak) + "</s> <b>€0</b></span></div></div>" : "";
    return '<div class="dpl-kaart" data-dpl-sleutel="' + esc(it.key) + '"><div class="dpl-regel">'
      + '<a href="' + esc(it.url) + '"><img class="dpl-foto" src="' + esc(beeld(it.image, 160)) + '" alt="' + esc(k.naam) + '" width="76" height="76"></a>'
      + '<div class="dpl-info"><div class="dpl-naamrij"><a class="dpl-naam" href="' + esc(it.url) + '">' + esc(k.naam) + "</a>" + prijs + "</div>"
      + (k.sub ? '<div class="dpl-sub">' + esc(k.sub) + "</div>" : "")
      + '<div class="dpl-acties"><div class="dpl-teller"><button type="button" data-dpl="min" aria-label="Eén minder">−</button><span>' + it.quantity + '</span><button type="button" data-dpl="plus" aria-label="Eén meer">+</button></div>'
      + '<button type="button" class="dpl-weg" data-dpl="weg" aria-label="' + esc(k.naam) + ' verwijderen">' + ICOON.weg + "</button></div></div></div>" + pakket + "</div>";
  }
  function cadeauHtml(it) {
    var k = kort(it.product_title, it.variant_title);
    return '<div class="dpl-cadeau"><img class="dpl-klein" src="' + esc(beeld(it.image, 112)) + '" alt="' + esc(k.naam) + '" width="56" height="56">'
      + '<div class="dpl-tekstblok"><b>' + esc(k.naam) + "</b>" + (k.sub ? "<span>" + esc(k.sub) + "</span>" : "") + "</div>"
      + '<span class="dpl-cadeau-prijs"><s>' + geld(it.original_line_price) + "</s> <b>" + geld(it.final_line_price) + "</b></span></div>";
  }
  function upsellHtml(lijst) {
    if (!lijst.length) return "";
    return '<div class="dpl-upsell"><div class="dpl-upsell-kop">Maak je bestelling compleet</div>' + lijst.map(function (u, i) {
      var k = kort(u.titel);
      return '<div class="dpl-up"><img class="dpl-klein" src="' + esc(beeld(u.beeld, 112)) + '" alt="' + esc(k.naam) + '" width="56" height="56">'
        + '<div class="dpl-tekstblok"><b>' + esc(k.naam) + "</b>" + (k.sub ? "<span>" + esc(k.sub) + "</span>" : "")
        + '<span class="dpl-up-prijs"><b>' + esc(u.prijs) + "</b>" + (u.oud ? " <s>" + esc(u.oud) + "</s>" : "") + "</span></div>"
        + '<button type="button" class="dpl-erbij" data-dpl="erbij" data-dpl-i="' + i + '">Toevoegen</button></div>';
    }).join("") + "</div>";
  }
  function voetHtml(cart, v, tr) {
    var som = "";
    if (v.sluit) {
      som += "<div><span>Subtotaal</span><span>" + geld(v.subtotaal) + "</span></div>";
      if (tr && tr.tiers.some(function (t) { return t.type === "shipping-discount" && tr.totaal >= t.threshold; })) som += "<div><span>Verzending</span><b>Gratis</b></div>";
      if (v.gratis > 0) som += "<div><span>Gratis cadeaus</span><b>−" + geld(v.gratis) + "</b></div>";
      v.kortingen.forEach(function (k) { som += "<div><span>" + esc(k.naam) + "</span><b>−" + geld(k.bedrag) + "</b></div>"; });
    } else {
      som += "<div><span>Subtotaal</span><span>" + geld(cart.items_subtotal_price) + "</span></div>";
      if (tr && tr.tiers.some(function (t) { return t.type === "shipping-discount" && tr.totaal >= t.threshold; })) som += "<div><span>Verzending</span><b>Gratis</b></div>";
    }
    return '<footer class="dpl-voet"><div class="dpl-som">' + som + '</div>'
      + '<div class="dpl-totaal"><span>Totaal</span><div><b>' + geld(cart.total_price) + "</b>" + (v.sluit && v.bespaard > 0 ? "<span>Je bespaart " + geld(v.bespaard) + "</span>" : "") + "</div></div>"
      + '<button type="button" class="dpl-betaal" data-dpl="betaal">Betalen<span class="dpl-bedrag"> · ' + geld(cart.total_price) + "</span></button>"
      + '<div class="dpl-vertrouwen"><div>' + ICOON.doos + "Discreet verzonden</div><div>" + ICOON.terug + "45 dagen bekijken</div></div></footer>";
  }

  /* ── het paneel ────────────────────────────────────────────────────────────────────────────────────────── */
  var stand = null, paneel = null, lijf = null, laatsteSig = null, laatsteCart = null, laatsteUps = [], laadPlan = null, bezigTot = 0, opgegeven = false, koopKlikOp = 0;
  function maakPaneel() {
    paneel = document.createElement("div");
    paneel.className = "dpl";
    paneel.setAttribute("role", "dialog");
    paneel.setAttribute("aria-label", "Winkelwagen");
    paneel.setAttribute("data-dpl-arm", stand.arm);
    paneel.innerHTML = '<header class="dpl-kop"><div class="dpl-titel">Winkelwagen <span></span></div><button type="button" class="dpl-sluit" data-dpl="sluit" aria-label="Sluiten">' + ICOON.sluit + '</button></header><div class="dpl-lijf"></div>';
    lijf = paneel.querySelector(".dpl-lijf");
    document.body.appendChild(paneel);
    paneel.addEventListener("click", klik);
    // klikfeedback (25-10): de knop onder de vinger krijgt meteen de klasse is-druk, los van :active (die geeft iOS en
    // een tik niet altijd); loslaten, wegschuiven of afbreken haalt hem weg, de tint zakt in 150 ms terug (dp-lade.css)
    var gedrukt = null;
    var los = function () { if (gedrukt) { gedrukt.classList.remove("is-druk"); gedrukt = null; } };
    paneel.addEventListener("pointerdown", function (e) {
      var k = e.target && e.target.closest && e.target.closest(".dpl button");
      los();
      if (k) { gedrukt = k; k.classList.add("is-druk"); }
    }, true);
    ["pointerup", "pointercancel", "pointerleave"].forEach(function (s) { paneel.addEventListener(s, los, true); });
    window.addEventListener("blur", los);
    paneel.addEventListener("keydown", function (e) { if (e.key === "Escape") sluit(); });
  }
  function teken(cart, ups) {
    var betaald = (cart.items || []).filter(function (i) { return !isCadeau(i); });
    var geschenk = (cart.items || []).filter(isCadeau);
    var n = betaald.reduce(function (s, i) { return s + i.quantity; }, 0);
    paneel.querySelector(".dpl-titel span").textContent = "(" + n + ")";
    var oudeVoet = paneel.querySelector(".dpl-voet");
    if (oudeVoet) oudeVoet.parentNode.removeChild(oudeVoet);
    if (!betaald.length) {
      lijf.innerHTML = '<div class="dpl-leeg"><div>Je winkelwagen is leeg</div><button type="button" data-dpl="sluit">Verder winkelen</button></div>';
      return;
    }
    var scroll = lijf.scrollTop;
    var tr = treden(cart);
    lijf.innerHTML = balkHtml(tr) + betaald.map(regelHtml).join("")
      + (geschenk.length ? '<div class="dpl-cadeaus">' + geschenk.map(cadeauHtml).join("") + "</div>" : "")
      + upsellHtml(ups);
    lijf.scrollTop = scroll;
    var v = voetRegels(cart, info, cadeaus);
    paneel.insertAdjacentHTML("beforeend", voetHtml(cart, v, tr));
    if (!v.sluit && window.console) console.warn("[dp-lade] de voet sluit niet op het totaal; alleen subtotaal en totaal getoond", v);
  }
  function laad(metVoorschot) {
    laadPlan = null;
    // bij het openen: wagen en cadeau-sectie tegelijk (scheelt een rondgang); de productinfo staat meestal al klaar
    // (voorladen), en de cadeaus van Kaching hebben geen adviesprijs nodig, dus daar wordt niet op gewacht
    var voorschot = metVoorschot === true ? cadeausVoorschot() : null;
    return fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var handles = [], ids = [];
        (cart.items || []).forEach(function (i) { if (isCadeau(i)) return; if (handles.indexOf(i.handle) < 0) handles.push(i.handle); if (ids.indexOf(String(i.product_id)) < 0) ids.push(String(i.product_id)); });
        return Promise.all([Promise.all(handles.map(haalInfo)), haalCadeaus(ids, voorschot)]).then(function () { return cart; });
      })
      .then(function (cart) {
        var ups = upsells();
        var sig = JSON.stringify([cart.token, cart.total_price, (cart.items || []).map(function (i) { return [i.key, i.quantity, i.final_line_price]; }), cart.cart_level_discount_applications, ups.map(function (u) { return [u.handle, u.prijs]; })]);
        laatsteCart = cart; laatsteUps = ups;
        if (sig !== laatsteSig) { laatsteSig = sig; teken(cart, ups); }
        paneel.classList.remove("dpl-wacht");
        bezigTot = 0;
        Array.prototype.forEach.call(paneel.querySelectorAll(".dpl-bezig"), function (x) { x.classList.remove("dpl-bezig"); });
        if (isOpen() && (cart.items || []).some(function (i) { return !isCadeau(i); })) meld("lade", stand);
      })
      .catch(function (e) {
        // liever de lade van Kaching dan een lege of halve: paneel weg, Kachings lade weer zichtbaar, tot de volgende pagina
        if (window.console) console.warn("[dp-lade] laden mislukt, terug naar de lade van Kaching", e);
        opgegeven = true;
        try { document.documentElement.classList.remove("dpl-aan"); paneel.classList.remove("dpl-open"); paneel.style.display = "none"; } catch (f) { /* niets */ }
      });
  }
  function planLaad(ms) { if (laadPlan) clearTimeout(laadPlan); laadPlan = setTimeout(laad, ms || 200); }
  /** Kaching zet een cadeau of een upsell-korting soms pas seconden ná een wijziging in de wagen, en niet altijd via een
      fetch die wij zien: kijk daarom na het openen en na elke klik nog twee keer, zolang de lade open is. */
  var naKijk = [];
  function kijkNa() {
    naKijk.forEach(clearTimeout);
    naKijk = [2500, 6000].map(function (ms) { return setTimeout(function () { if (isOpen() && !opgegeven) laad(); }, ms); });
  }
  function isOpen() { return document.documentElement.classList.contains(OPEN_KLASSE); }
  function sluit() {
    try { if (window.kachingCartApi && window.kachingCartApi.closeCart) { window.kachingCartApi.closeCart(); return; } } catch (e) { /* door */ }
    var x = document.querySelector(".kaching-cart__close"); if (x) x.click();
  }
  function kachingRegel(sleutel) {
    var lijst = document.querySelectorAll(".kaching-cart-item[data-line-key]");
    for (var i = 0; i < lijst.length; i++) if (lijst[i].getAttribute("data-line-key") === sleutel) return lijst[i];
    return null;
  }
  function wijzig(sleutel, aantal) {
    // terugval als Kachings eigen knop er niet is: dezelfde wijziging via Shopify, daarna laat Kaching zijn tredes herrekenen
    return fetch("/cart/change.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: sleutel, quantity: aantal }) })
      .then(function () { try { if (window.kachingCartApi && window.kachingCartApi.refreshCart) window.kachingCartApi.refreshCart(); } catch (e) { /* niets */ } planLaad(300); });
  }
  function klik(e) {
    var knop = e.target && e.target.closest && e.target.closest("[data-dpl]");
    if (!knop) return;
    var soort = knop.getAttribute("data-dpl");
    if (soort !== "sluit" && soort !== "betaal") kijkNa();
    if (soort === "sluit") { e.preventDefault(); sluit(); return; }
    if (soort === "betaal") {
      e.preventDefault();
      meld("afrekenen", stand);
      var echt = document.getElementById("kaching-cart__checkout-button");
      if (echt) echt.click(); else location.href = "/checkout";
      return;
    }
    if (soort === "erbij") {
      e.preventDefault();
      var u = laatsteUps[Number(knop.getAttribute("data-dpl-i"))];
      if (u && u.knop && document.contains(u.knop)) { knop.classList.add("dpl-bezig"); u.knop.click(); planLaad(1200); }
      else planLaad(0);
      return;
    }
    var kaart = knop.closest(".dpl-kaart");
    if (!kaart || !laatsteCart) return;
    e.preventDefault();
    var sleutel = kaart.getAttribute("data-dpl-sleutel");
    var it = (laatsteCart.items || []).filter(function (i) { return i.key === sleutel; })[0];
    if (!it) return;
    kaart.classList.add("dpl-bezig");
    var regel = kachingRegel(sleutel);
    var doel = soort === "plus" ? it.quantity + 1 : soort === "min" ? it.quantity - 1 : 0;
    var kn = null;
    if (regel) {
      if (doel <= 0) kn = regel.querySelector(".kaching-cart-item__remove-btn");
      else if (soort === "plus") kn = regel.querySelector(".kaching-cart-item__quantity-btn--increment");
      else kn = regel.querySelector(".kaching-cart-item__quantity-btn--decrement");
    }
    if (kn) { kn.click(); planLaad(1200); } else wijzig(sleutel, Math.max(0, doel));
    setTimeout(function () { if (kaart.classList.contains("dpl-bezig")) planLaad(0); }, 5000);
  }
  function synchroon() {
    if (opgegeven) return;
    var open = isOpen();
    if (open && !paneel.classList.contains("dpl-open")) {
      // vlak na een klik op een koopknop staat in het paneel nog de wagen van daarvoor: tot de verse lezing er is, zijn de
      // kaarten gedimd en de bedragen leeg (een bedrag dat nog niet vaststaat tonen we niet)
      if (Date.now() - koopKlikOp < 8000) paneel.classList.add("dpl-wacht");
      paneel.classList.add("dpl-open");
      laad(true); kijkNa();
    } else if (!open && paneel.classList.contains("dpl-open")) {
      paneel.classList.remove("dpl-open");
    }
  }

  /* ── start ─────────────────────────────────────────────────────────────────────────────────────────────── */
  function startMeten() {
    // beide armen: Betalen in Kachings eigen lade (arm A, en in arm B via onze knop die hem indrukt)
    document.addEventListener("click", function (e) {
      var k = e.target && e.target.closest && e.target.closest("#kaching-cart__checkout-button");
      if (k) meld("afrekenen", stand);
    }, true);
    if (stand.arm !== "A") return;
    // arm A: "lade" zodra Kachings lade opengaat met iets in de wagen
    var keek = false;
    var kijk = function () {
      if (!isOpen()) { keek = false; return; }
      if (keek) return;
      keek = true;
      fetch("/cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (c) {
        if ((c.items || []).some(function (i) { return !isCadeau(i); })) meld("lade", stand);
      }).catch(function () {});
    };
    new MutationObserver(kijk).observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    kijk();
  }
  function startPaneel() {
    document.documentElement.classList.add("dpl-aan");
    // voorladen: de adviesprijs van het product op deze pagina, zodat de lade na In winkelwagen niet daarop wacht
    var hp = (location.pathname || "").match(/\/products\/([^\/?#]+)/);
    if (hp) { try { haalInfo(decodeURIComponent(hp[1]).toLowerCase()); } catch (e) { /* niets */ } }
    var koopKlik = function (e) { if (e.target && e.target.closest && e.target.closest("form[action*='/cart/add']")) koopKlikOp = Date.now(); };
    document.addEventListener("click", koopKlik, true);
    document.addEventListener("submit", koopKlik, true);
    // :active op een tik (iOS geeft :active alleen met een touchstart-luisteraar)
    document.addEventListener("touchstart", function () {}, { passive: true });
    maakPaneel();
    new MutationObserver(synchroon).observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    // Kaching tekent zijn (onzichtbare) lade opnieuw na elke wijziging aan de wagen: dan opnieuw lezen
    var drawerKijker = null;
    var hang = function () {
      var d = document.querySelector("kaching-cart-drawer");
      if (!d || d === drawerKijker) return;
      drawerKijker = d;
      new MutationObserver(function () { if (isOpen()) planLaad(250); }).observe(d, { childList: true, subtree: true, characterData: true });
    };
    hang();
    new MutationObserver(hang).observe(document.body, { childList: true });
    if (window.fetch) {
      var oud = window.fetch;
      window.fetch = function (invoer) {
        var url = typeof invoer === "string" ? invoer : (invoer && invoer.url);
        var p = oud.apply(this, arguments);
        if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ""))) p.then(function () { if (isOpen()) planLaad(300); }, function () {});
        return p;
      };
    }
    synchroon();
  }
  function start() {
    stand = paginaArm();
    if (!stand) return;
    try { startMeten(); } catch (e) { /* alleen de meting valt weg */ }
    if (stand.arm !== "B") return;
    try { startPaneel(); }
    catch (e) {
      // terug naar de lade van Kaching
      try { document.documentElement.classList.remove("dpl-aan"); if (paneel && paneel.parentNode) paneel.parentNode.removeChild(paneel); } catch (f) { /* niets */ }
    }
  }
  // voor de proef en de test: de rekenregels van buitenaf te lezen, verder niets
  window.dpLade = { kort: kort, geld: geld, voetRegels: voetRegels, paginaArm: paginaArm };
  try {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
  } catch (e) { /* de lade blijft die van Kaching */ }
})();
